module.exports = __webpack_public_path__ + "img/sub6.c0c49054.png";